import { SectionListingModel, SectionModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class SectionService {
  private static baseUrl: string = '/api/section';
  static tags = {
    getSections: 'getSections',
    getSection: 'getSection',
    updateSection: 'updateSection',
    deleteSection: 'deleteSection',
  };

  static getSectionListings = (): Promise<SectionListingModel[]> => {
    return trackPromise(
      new Promise<SectionListingModel[]>((resolve, reject) => {
        http(`${this.baseUrl}/listing`)
          .get<SectionListingModel[]>()
          .then((response) => response.map((sc) => new SectionListingModel(sc)))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.getSections,
    );
  };

  static getSection = (salesCategoryId: number): Promise<SectionModel> => {
    return trackPromise(
      new Promise<SectionModel>((resolve, reject) => {
        http(`${this.baseUrl}/${salesCategoryId}`)
          .get<SectionModel>()
          .then((response) => new SectionModel(response))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.getSection,
    );
  };

  static upsertSection = (data: SectionModel): Promise<SectionModel> => {
    return trackPromise(
      new Promise<SectionModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<SectionModel>(data)
          .then((response) => {
            resolve(new SectionModel(response));
          })
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.updateSection,
    );
  };

  static deleteSection = (id: number): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${id}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.deleteSection,
    );
  };
}
